<div
  class="article-details-view-container"
  *ngIf="blogArticleObject"
  fxLayout="column"
  fxLayoutGap="15px"
>
  <div fxLayout="row" fxLayoutGap="15px">
    <button
      [disabled]="!(userPermissions | async).dobry_agent.write"
      (click)="modify()"
      mat-stroked-button
      color="primary"
    >
      <mat-icon>create</mat-icon>
      <span>Edytuj</span>
    </button>
    <button
      (click)="deleteWeak(blogArticleObject.uuid)" mat-stroked-button>
      <mat-icon>archive</mat-icon>
      <span> Przenieś do archiwum</span>
    </button>
    <button
      (click)="delete(blogArticleObject)" mat-stroked-button color="warn">
      <mat-icon>delete</mat-icon>
      <span> Usuń</span>
    </button>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxLayout="column" fxFlex="50" fxFlex.lt-lg="100" fxLayoutGap="15px">
      <mat-card fxLayout="column">
        <app-section-header
          title="Dane artykułu"
          description="Podstawowe informacje, treść i ustawienia publikacji."
        ></app-section-header>

        <app-detail header="Nazwa" [value]="blogArticleObject.name"></app-detail>
        <img
          *ngIf="getArticleImage(blogArticleObject) as articleImage; else noArticleImage"
          class="article-image-preview"
          [src]="articleImage"
          [alt]="blogArticleObject.altImage || 'Zdjęcie artykułu'"
        >

        <ng-template #noArticleImage>
          <span>Brak zdjęcia</span>
        </ng-template>
        <app-detail header="Alt obrazka" [value]="blogArticleObject.altImage"></app-detail>
        <app-detail fxFlex="100" header="Link do artykyłu">
          <a class="default-link" [href]="blogArticleObject?.articleUrl"
             target="_blank">{{ blogArticleObject?.articleUrl }}</a>
        </app-detail>
        <div fxLayout="row" fxLayoutGap="15px">

          <div fxFlex="33">
            <app-detail
              header="Pozycja"
              [value]="blogArticleObject.position !== undefined ? blogArticleObject.position.toString() : ''"
            ></app-detail>
          </div>

          <div fxFlex="33">
            <app-detail
              header="Data publikacji"
              [value]="blogArticleObject.publicationDate | date:'y-MM-dd HH:mm '"
            ></app-detail>
          </div>
          <div fxFlex="33">
            <app-detail
              header="Status"
            >
              <app-detail-bool
                [header]="blogArticleObject.active ? 'Aktywny': 'Nieaktywny'"
                [value]="blogArticleObject.active"
              ></app-detail-bool>
            </app-detail>
          </div>
        </div>


        <app-detail header="Krótki opis" [value]="blogArticleObject.shortDescription"></app-detail>

        <app-detail header="Treść">
          <span [innerHTML]="blogArticleObject.description"></span>
        </app-detail>


      </mat-card>
    </div>

    <div fxLayout="column" fxFlex="50" fxFlex.lt-lg="100" fxLayoutGap="15px">
      <mat-card fxLayout="column">
        <app-section-header
          title="Powiązania"
          description="Kategorie, autorzy i inne elementy powiązane z artykułem."
        ></app-section-header>
        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="15px">

          <app-detail
            fxFlex="50"
            header="Kategoria"
            [value]="blogArticleObject.blogCategory?.name"
            [link]="['/blog-dobry-agent/kategorie/szczegoly', blogArticleObject?.blogCategory?.uuid]"
          ></app-detail>

          <app-detail
            fxFlex="50"
            header="Kategoria ubezpieczenia"
            [value]="blogArticleObject.insuranceCategory?.name"
          ></app-detail>
        </div>
        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="15px">
          <app-detail
            fxFlex="50"
            header="Autor"
            [value]="(blogArticleObject.author?.firstName || '') + ' ' + (blogArticleObject.author?.lastName || '')"
            [link]="['/blog-dobry-agent/autorzy/szczegoly', blogArticleObject?.author?.uuid]"
          ></app-detail>

          <app-detail
            fxFlex="50"
            header="Doradca - dobryagent.pl"
            [value]="(blogArticleObject.coordinator?.firstName || '') + ' ' + (blogArticleObject.coordinator?.lastName || '')"
          ></app-detail>
        </div>
        <app-detail header="Powiązana placówka">
          <ng-container *ngIf="blogArticleObject.relatedFacility; else noRelatedFacility">
            <div class="related-facility" fxLayout="row" fxLayoutGap="15px" fxLayout.lt-md="column">
              <img
                *ngIf="getFacilityImage(blogArticleObject.relatedFacility) as facilityImage"
                class="related-facility__image"
                [src]="facilityImage"
                [alt]="blogArticleObject.relatedFacility.altImage || blogArticleObject.relatedFacility.name || 'Placówka'"
              >

              <div fxLayout="column" fxLayoutGap="6px">
                <a
                  class="default-link"
                  [routerLink]="['/placowki/szczegoly', blogArticleObject.relatedFacility.uuid]"
                >
                  {{ blogArticleObject.relatedFacility.name || blogArticleObject.relatedFacility.shortName }}
                </a>

                <span *ngIf="blogArticleObject.relatedFacility.address">
          {{ blogArticleObject.relatedFacility.address.searchString }}

        </span>

                <span *ngIf="blogArticleObject.relatedFacility.phone">
          Tel. {{ blogArticleObject.relatedFacility.phone }}
        </span>

                <span *ngIf="blogArticleObject.relatedFacility.email">
          {{ blogArticleObject.relatedFacility.email }}
        </span>
              </div>
            </div>
          </ng-container>

          <ng-template #noRelatedFacility>
            <span>Brak powiązanej placówki</span>
          </ng-template>
        </app-detail>
        <app-detail
          header="Powiązany artykuł"
        >
          <div class="related-article">
            <ng-container *ngFor="let relatedArticle of blogArticleObject.relatedArticles; let i = index">
              <span>{{ i + 1 }} - {{ relatedArticle.name }}</span>
            </ng-container>
          </div>
        </app-detail>
        <app-detail header=" Tagi">
          <mat-chip-list>
            <ng-container *ngFor="let tagPartner of blogArticleObject.blogTags">
              <mat-chip selected>{{ tagPartner.name }}</mat-chip>
            </ng-container>
          </mat-chip-list>
        </app-detail>

      </mat-card>

      <mat-card fxLayout="column">
        <app-section-header
          title="SEO"
          description="Ustawienia widoczności artykułu w wynikach wyszukiwania."
        ></app-section-header>

        <app-detail header="Slug SEO" [value]="blogArticleObject.seoSlug"></app-detail>
        <app-detail header="Tytuł SEO" [value]="blogArticleObject.seoTitle"></app-detail>
        <app-detail header="Opis SEO" [value]="blogArticleObject.seoDescription"></app-detail>
        <app-detail header="Słowa kluczowe SEO" [value]="blogArticleObject.seoKeywords"></app-detail>
      </mat-card>
    </div>
  </div>
</div>
